const state = {
  relatedVideos: {},
  isFetchingVideos: false,
  isManualSearch: false,
  videoErrors: 0,
  videoEnabled: true,
  nextPage: 1,
};

const PAGE_SIZE = 10;

const actions = {
  searchRelatedVideos(
    { commit, state, rootState },
    { title, body, isManualSearch },
  ) {
    const token = rootState.user.currentUser.token;
    commit('SET_FETCHING_VIDEOS', true);
    commit('SET_IS_MANUAL_SEARCH', isManualSearch);
    rootState.pautaClient
      .getRelatedVideos(
        token,
        title,
        body,
        isManualSearch,
        PAGE_SIZE,
        state.nextPage,
      )
      .then(videos => {
        commit('UPDATE_RELATED_VIDEOS', videos);
      })
      .catch(error => {
        commit('news/UPDATE_FEEDBACK_MESSAGE', error.response.data.detail, {
          root: true,
        });
      })
      .finally(() => {
        commit('SET_FETCHING_VIDEOS', false);
      });
  },
  updateManualSearch({ commit }, value) {
    commit('SET_IS_MANUAL_SEARCH', value);
  },
  updateVideosEnabled({ commit }, value) {
    commit('UPDATE_VIDEO_ENABLED_STATUS', value);
  },
  updateCountVideoErrors({ commit }, value) {
    commit('UPDATE_COUNT_VIDEO_ERRORS', value);
  },
  resetVideos({ commit }) {
    commit('RESET_VIDEOS');
  },
};

const mutations = {
  // eslint-disable-next-line no-unused-vars
  UPDATE_RELATED_VIDEOS(state, videos) {
    if (state.relatedVideos.globoi) {
      state.relatedVideos.globoi = state.relatedVideos.globoi.concat(
        videos.globoi,
      );
    } else {
      state.relatedVideos = {};
      state.relatedVideos = { ...videos };
    }
    state.nextPage++;
  },
  RESET_VIDEOS(state) {
    state.relatedVideos = {};
    state.nextPage = 1;
  },
  SET_FETCHING_VIDEOS(state, value) {
    state.isFetchingVideos = value;
  },
  SET_IS_MANUAL_SEARCH(state, value) {
    state.isManualSearch = value;
  },
  UPDATE_VIDEO_ENABLED_STATUS(state, value) {
    state.videoEnabled = value;
  },
  UPDATE_COUNT_VIDEO_ERRORS(state, value) {
    state.videoErrors = value;
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
